export const PROPERTY_TYPES = [
  ["single_family", "Single-family home"], ["condominium", "Condominium"], ["multi_family", "Multi-family"], ["coop", "Co-op"],
  ["manufactured", "Manufactured home"], ["unimproved", "Land / unimproved lot"], ["commercial", "Commercial"], ["other", "Other"],
];

export const IP_TYPES = {
  us_trademark: "U.S. trademark registration",
  us_trademark_madrid: "U.S. registration from the Madrid Protocol",
  us_utility_patent: "U.S. utility patent",
  us_reissue_patent: "U.S. reissue of a utility patent",
  us_design_patent: "U.S. design patent",
  us_plant_patent: "U.S. plant patent",
  other: "Other / non-U.S.",
};

export async function blobError(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail || "Something went wrong."; } catch { return "Something went wrong."; }
  }
  return null;
}


export function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function dateParts(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return { month: dt.toLocaleDateString("en-US", { month: "short" }), day: d };
}

export function formatBytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function daysBetween(fromIso, toIso) {
  const a = new Date(`${fromIso}T00:00:00`);
  const b = new Date(`${toIso}T00:00:00`);
  return Math.round((b - a) / 86400000);
}

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA",
  "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR",
  "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY", "PR", "GU", "VI",
];

const US_ZONES = [
  ["America/New_York", "Eastern Time"],
  ["America/Chicago", "Central Time"],
  ["America/Denver", "Mountain Time"],
  ["America/Phoenix", "Arizona (no DST)"],
  ["America/Los_Angeles", "Pacific Time"],
  ["America/Anchorage", "Alaska Time"],
  ["Pacific/Honolulu", "Hawaii Time"],
  ["America/Puerto_Rico", "Atlantic Time"],
];

export function timezoneOptions() {
  const us = US_ZONES.map(([value, label]) => ({ value, label: `${label} (${value})` }));
  const all = typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [];
  const usSet = new Set(US_ZONES.map(([v]) => v));
  return [...us, ...all.filter((z) => !usSet.has(z)).map((z) => ({ value: z, label: z }))];
}

export const REMINDER_REASONS = {
  record_deleted: "Record deleted",
  document_deleted: "Document deleted",
  deadline_updated: "Deadline changed",
  deadline_completed: "Deadline marked done",
  deadline_deleted: "Deadline deleted",
  not_confirmed: "Date no longer confirmed",
  expired: "Due date already passed",
};

export const reminderStatus = (r) => r.status === "pending" ? "Scheduled (about 8am)" : r.status === "sent" ? "Sent"
  : `Cancelled: ${REMINDER_REASONS[r.cancelled_reason] || r.cancelled_reason}`;
